//@ts-nocheck

import React, {useRef} from "react";
import { motion } from 'framer-motion';
import Layout from '../components/Layout/Layout'
import { Link } from 'react-router-dom';
import ActionBtn from './../components/Button/ActionBtn';

import { Col, Container, Row } from 'react-bootstrap'
import ComplaintsPolicy from '../assets/pdfs/Complaints Policy (1).pdf';
import CookiePolicy from '../assets/pdfs/Cookie Policy (1).pdf';
import CreditBuilderAccount from '../assets/pdfs/Credit Builder Account Futeur AI - Updated.docx.pdf';
import PrivacyPolicy from '../assets/pdfs/Privacy Policy.pdf';
import TermsAndConditions from '../assets/pdfs/Website Terms and Conditions.pdf';
import TerminalContact from "../components/TerminalContactForm";
import VerticalAccordion from "../components/Legal/VerticalAccordian";
import AccordionSolutions from "../components/Legal/AccordianSolutions";
import ContactPage from "../components/ContactForm/Contact";

import emailjs from '@emailjs/browser';

const legalDocuments = [
 
  { text: "Terms and Conditions", pdfUrl: TermsAndConditions, fileName: "Terms_and_Conditions.pdf" },
  { text: "Cookie Policy", pdfUrl: CookiePolicy, fileName: "Cookie_Policy.pdf" },
  { text: "Privacy Policy", pdfUrl: PrivacyPolicy, fileName: "Privacy_Policy.pdf" },
  { text: "Complaints Policy", pdfUrl: ComplaintsPolicy, fileName: "Complaints_Policy.pdf" },
];

const Legal = () => {
  const handlePdfDownload = (pdfUrl: string, fileName: string) => {
    fetch(pdfUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
  };
  // 1. Create a reference for the form
  const formRef = useRef();

  // 2. Create a handler for form submission
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_t80qe2q',   // Replace with your Service ID
        'template_tn7w75g', // Replace with your Template ID
        formRef.current,    // Reference to the form
        '37maWWNmcPSwXXr8W'  // Replace with your Public Key
      )
      .then(
        (result) => {
          console.log('SUCCESS!', result.text);
          // This alert will appear on successful email send
          alert('Your message has been sent successfully to our legal team. We will get back to you shortly.');
          // Optionally clear the form
          e.target.reset();
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert('Oops! Something went wrong. Please try again later.');
        }
      );
  };

  return (
    <Layout title="Legal" description="Legal Documents Page">
     <section className="pt-16 md:pt-24 lg:pt-32 pb-0 relative overflow-hidden">
        <img
          src="/images/Container.svg"
          className="absolute w-full h-full object-cover left-1/2 -translate-x-1/2 top-0 pointer-events-none"
          alt=""
        />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-[1]">
          <motion.h2 
            className="font-bold text-4xl sm:text-5xl md:text-6xl lg:text-6xl mb-4 sm:mb-6 text-black leading-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            The Cornerstones of FuteurAI 
          </motion.h2>
          <motion.h2 
            className="font-medium text-3xl sm:text-4xl md:text-5xl lg:text-5xl mb-4 sm:mb-6 text-black leading-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Transparency, Accountability, Trust
          </motion.h2>
          <motion.p 
            className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-8 sm:mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            At FuteurAI, we prioritize your trust.
            Explore our comprehensive legal framework designed to protect your data, ensure compliance, and empower fairness.
          </motion.p>
        </div>
      </section>
      <section className="py-12 sm:py-16 bg-gray-50">
        <Container className="px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {legalDocuments.map((doc, index) => (
              <motion.div
                key={doc.fileName}
                className="bg-white rounded-2xl sm:rounded-3xl shadow-md sm:shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-gray-800">{doc.text}</h3>
                  <div className="flex gap-3">
                    <ActionBtn
                      title="Download"
                      type={2}
                      isDownload={true}
                      pdfUrl={doc.pdfUrl}
                      fileName={doc.fileName}
                      onClick={() => handlePdfDownload(doc.pdfUrl, doc.fileName)}
                    />
                    {doc.text === "Terms and Conditions" && (
                     
                        <ActionBtn
                          link="/terms-and-conditions"
                          title="Learn More"
                          variant={2} // Orange button variant
                         size="normal"
                        />
                    
                    )}
                     {doc.text === "Privacy Policy" && (
                     
                     <ActionBtn
                       link="/privacy-policy"
                       title="Learn More"
                       variant={2} // Orange button variant
                      size="normal"
                     />
                 
                 )}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </Container>
      </section>
       <section className='py-2'>

                          <div className="xs:px-2">
                              <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] bg-Mneutral100 rounded-[24px] sm:rounded-[56px]">
                                  <Container>

                                      <div className="grid grid-rows-1 gap-y-6">
      
                                          <div className="w-full p-3 bg-white rounded-[32px]">
                                              <Row className='justify-between gap-y-3'>
                                                  <Col md={7} className='my-auto md:!order-1 order-2'>
                                                      <div className="lg:px-[4rem]">
                                                          <h4 className='font-medium text__48 mt-10 mb-10 text-black'>Your Data, Our Responsibility                                               </h4>
                                                          {/*
                                                          <p className='text__18 leading-relaxed mb-[1rem] text-black font-bold'>Advanced Data Protection
                                                          </p>
                                                          //*/}
                                                          <p className='text__18 leading-relaxed mb-[3rem] text-black' >At FuteurAI, data security isn’t just a policy it’s a promise. We deploy state
                                                          of the art encryption, AI-driven threat detection, and a zero trust 
                                                          architecture to protect your information against vulnerabilities.</p>

                                                      </div>
                                                  </Col>
                                                  <Col md={5} className='my-auto order-1 md:!order-2'>
                                                      <img src={"/legal/handshake.jpg"} alt="" className="rounded-[32px]"/>
                                                  </Col>
                                              </Row>
                                          </div>

                                      </div>
      
                                  </Container>
                              </div>
                          </div>
      
                      </section>
                  <VerticalAccordion  />

                <section className='py-2'>

                       <div className="xs:px-2">
                           <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] bg-Mneutral100 rounded-[24px] sm:rounded-[56px]">
                               <Container>
                              
                                   <div className="grid grid-rows-1 gap-y-6">
   
                                       <div className="w-full p-3 bg-white rounded-[32px]">
                                           <Row className='justify-between gap-y-3'>
                                               <Col md={7} className='my-auto md:!order-1 order-2'>
                                                   <div className="lg:px-[4rem]">
                                                       <h4 className='font-medium text__48 mt-10 mb-10 text-black'>Ethics and Compliance Our Guiding Principles                                               </h4>
                                                      
                                                        <p className='text__18 leading-relaxed mb-[3rem] text-black' >Our operations are aligned with global compliance standards, ensuring 
ethical practices across all interactions. Discover our dedication to 
transparency and regulatory adherence.</p>

                                                   </div>
                                               </Col>
                                               <Col md={5} className='my-auto order-1 md:!order-2'>
                                                   <img src={"/legal/guide.jpg"} alt="" className="rounded-[24px]"/>
                                               </Col>
                                           </Row>
                                       </div>
                                      
                                   </div>
   
                               </Container>
                           </div>
                       </div>
   
                   </section>
                   <AccordionSolutions />
                      <section className='py-2'>
                   
                                   <div className="px-2">
                                       <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] bg-Mneutral100 rounded-[24px] sm:rounded-[56px]">
                                           <Container className="relative z-[1] mt-[3rem]">
                   
                                               <Row className='gap-y-4'>
                                                   <Col md={6}>
                                                       <h2 className='font-medium text__64 mb-2 text-black'>Your Trust, Our  <br />
                                                       Priority</h2>
                                                       <p className='text__18 leading-relaxed text-Mneutral700'>Have additional questions or concerns? Our legal team is here to help. Let’s work together to ensure your confidence in FuteurAI. </p>
                   
                                                       <div className="my-3">
                                                           <p className='text__18 leading-relaxed text-Mneutral700'>Contact Legal Support</p>
                                                           <a href="mailto:hello@legal@futeur.ai" className='font-medium text__24 text-Mneutral900'>legal@futeur.ai</a>
                                                       </div>
                                                      
                                                   </Col>
                                                    <Col md={6}>
                                                                      <form
                                                                        ref={formRef}
                                                                        onSubmit={sendEmail}
                                                                        className="w-full p-8 rounded-[32px] bg-white"
                                                                      >
                                                                        <Row className='gap-y-3'>
                                                                          <Col md={6}>
                                                                            <label
                                                                              className='font-medium text__12 text-Mneutral700 mb-2'
                                                                              htmlFor="first_name"
                                                                            >
                                                                              First Name
                                                                            </label>
                                                                            <input
                                                                              type="text"
                                                                              id="first_name"
                                                                              name="first_name"
                                                                              placeholder='Enter your first name...'
                                                                              className='w-full h-[46px] px-3 rounded-full bg-Mneutral50 border !border-Mneutral200 outline-none hover:focus:active:outline-none font-medium text__14 placeholder:text-Mneutral400 text-Mneutral900'
                                                                              required
                                                                            />
                                                                          </Col>
                                                                          <Col md={6}>
                                                                            <label
                                                                              className='font-medium text__12 text-Mneutral700 mb-2'
                                                                              htmlFor="last_name"
                                                                            >
                                                                              Last Name
                                                                            </label>
                                                                            <input
                                                                              type="text"
                                                                              id="last_name"
                                                                              name="last_name"
                                                                              placeholder='Enter your last name...'
                                                                              className='w-full h-[46px] px-3 rounded-full bg-Mneutral50 border !border-Mneutral200 outline-none hover:focus:active:outline-none font-medium text__14 placeholder:text-Mneutral400 text-Mneutral900'
                                                                              required
                                                                            />
                                                                          </Col>
                                                                          <Col md={12}>
                                                                            <label
                                                                              className='font-medium text__12 text-Mneutral700 mb-2'
                                                                              htmlFor="email"
                                                                            >
                                                                              Email
                                                                            </label>
                                                                            <input
                                                                              type="email"
                                                                              id="email"
                                                                              name="email"
                                                                              placeholder='Enter your email address...'
                                                                              className='w-full h-[46px] px-3 rounded-full bg-Mneutral50 border !border-Mneutral200 outline-none hover:focus:active:outline-none font-medium text__14 placeholder:text-Mneutral400 text-Mneutral900'
                                                                              required
                                                                            />
                                                                          </Col>
                                                                          <Col md={12}>
                                                                            <label
                                                                              className='font-medium text__12 text-Mneutral700 mb-2'
                                                                              htmlFor="message"
                                                                            >
                                                                              How can we help you?
                                                                            </label>
                                                                            <textarea
                                                                              id="message"
                                                                              name="message"
                                                                              placeholder='Enter your message...'
                                                                              className='w-full h-[144px] px-3 py-2 rounded-[20px] bg-Mneutral50 border !border-Mneutral200 outline-none hover:focus:active:outline-none font-medium text__14 placeholder:text-Mneutral400 text-Mneutral900'
                                                                              required
                                                                            />
                                                                          </Col>
                                                                        </Row>
                                                  
                                                                        <div className="mt-[2rem] text-right">
                                                                          {/* Submit Button with Alert on Success */}
                                                                          <ActionBtn 
                                                                          title="Send Message"
                                                                          variant={3}     // black background with white text
                                                                          isSubmit={true} // renders <button type="submit">
                                                                        />
                                                                        </div>
                                                                      </form>
                                                                    </Col>
                                                                    {/* FORM END */}
                                               </Row>
                   
                                           </Container>
                                       </div>
                                   </div>
                   
                               </section>
                   
    </Layout>
  );
};

export default Legal;
